var _style, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreymenuicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:lightgrey;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,28H8c-2.2,0-4-1.8-4-4V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v16C28,26.2,26.2,28,24,28z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    x2: 22,
    y1: 16,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    x2: 22,
    y1: 12,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    x2: 22,
    y1: 20,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreymenuicon);
export default __webpack_public_path__ + "static/media/greymenuicon.ed95a237a5d4ab90384a50a904056437.svg";
export { ForwardRef as ReactComponent };